/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Resource action required identifier. 
*/
export enum ActionRequiredDetails {
  CloudResourceActionRequiredUnspecified = 'CLOUD_RESOURCE_ACTION_REQUIRED_UNSPECIFIED',
  AzureSqlVmInvalidConfiguration = 'AZURE_SQL_VM_INVALID_CONFIGURATION',
  DynamoDbInvalidStreamViewType = 'DYNAMO_DB_INVALID_STREAM_VIEW_TYPE',
  DynamoDbInsufficientRcus = 'DYNAMO_DB_INSUFFICIENT_RCUS',
  RdsDatabaseStopped = 'RDS_DATABASE_STOPPED',
  BigqueryChangeHistoryDisabled = 'BIGQUERY_CHANGE_HISTORY_DISABLED'
}
